import { render, staticRenderFns } from "./helpList.vue?vue&type=template&id=4c2fdb33&"
import script from "./helpList.vue?vue&type=script&lang=js&"
export * from "./helpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports